<template>
    <BaseBtn v-if="!disabled" v-on="$listeners" icon="calendar-check" label="Check-in" :id="id" />
    <b-button v-else checked variant="light" class="btn-disabled" :id="id">
        <i :class="`icon fa fa-calendar-check mr-2`" />
        <slot>
            <span>{{ 'Check-in' }}</span>
        </slot>
        <b-tooltip :target="id">
            {{ $t('hasNotCheckinAuthorization') }}
        </b-tooltip>
    </b-button>
</template>

<script>
import BaseBtn from './BaseBtn'

export default {
    name: 'CheckInBtn',
    components: {
        BaseBtn,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
    },
    i18n: {
        messages: {
            'en-US': {
                hasNotCheckinAuthorization: 'You are not authorized to check-in this Key Result',
            },
            'es-ES': {
                hasNotCheckinAuthorization: 'No está autorizado para registrar este Resultado Clave',
            },
            'pt-BR': {
                hasNotCheckinAuthorization: 'Você não tem autorização para realizar um check-in neste Resultado Chave',
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.icon {
    font-size: 14px;
    margin-bottom: 0;
}
.btn-disabled {
    display: flex;
    align-items: center;
    color: #009ada;
    font-size: 12px;
    font-weight: 400;
    border: 1px solid #009ada;
    white-space: nowrap;
    opacity: 0.65;
}
</style>
